import { Link, useLocation } from 'react-router-dom';

interface BreadcrumbItem {
  label: string;
  href?: string;
}

export default function Breadcrumb({ items }: { items: BreadcrumbItem[] }) {
  const location = useLocation();

  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, idx) => ({
      '@type': 'ListItem',
      position: idx + 1,
      name: item.label,
      item: item.href ? `http://ahljjx.cn/${item.href}` : `http://ahljjx.cn/${location.pathname}`,
    })),
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
      />
      <nav aria-label="面包屑导航" className="max-w-[1400px] mx-auto px-4 md:px-6 pt-24 pb-4">
        <ol className="flex items-center gap-1.5 text-xs text-foreground-400 flex-wrap">
          <li>
            <Link to="/" className="hover:text-primary-500 transition-colors cursor-pointer">首页</Link>
          </li>
          {items.map((item, idx) => (
            <li key={idx} className="flex items-center gap-1.5">
              <span className="text-foreground-300">/</span>
              {item.href ? (
                <Link to={item.href} className="hover:text-primary-500 transition-colors cursor-pointer">
                  {item.label}
                </Link>
              ) : (
                <span className="text-foreground-700 font-medium">{item.label}</span>
              )}
            </li>
          ))}
        </ol>
      </nav>
    </>
  );
}